import { gql } from '@apollo/client';

export const GET_WHS_DAILY_TASK_MONITORING_LIST = gql`
  query GetWhsDailyTaskMonitoringList($warehouseId: Long!, $filter: DailyTaskMonitoringFilterTypeInput!, $pageRequest: DailyTaskPageRequestTypeInput!) {
    getWhsDailyTaskMonitoringList(warehouseId: $warehouseId, filter: $filter, pageRequest: $pageRequest) {
      calculatedAt
      summaryData {
        deliveryProgress {
          scheduledParcels
          actualPickedUp
          deliveredParcels
          pickupRate
          deliveryRate
        }
        undeliveredDistribution {
          totalUndelivered
          unpicked
          inDelivery
          failedReturned
          failedNotReturned
          warehouseLost
        }
      }
      recordData {
        id
        taskDate
        warehouseId
        warehouseName
        dspId
        dspName
        areaId
        driverId
        allocatedParcels
        pickedUpFromWarehouse
        warehouseLost
        inDelivery
        deliveryRate
        onTimeDelivery
        overdueDelivery
        deliveredCount
        unclaimedCount
        noAscanDelivery
        transferredIn
        transferredOut
        returned
        damaged
        driverName
        lastDeliveryTime
        dwellTime
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
`;

// 使用daily task API的详情查询
export const GET_DAILY_TASK_MONITORING_DETAIL_LIST = gql`
  query GetDailyTaskMonitoringDetailList($pageRequest: DailyTaskMonitoringDetailPageRequestTypeInput!) {
    getDailyTaskMonitoringDetailList(pageRequest: $pageRequest) {
      content {
        id
        taskDate
        warehouseId
        dspId
        areaId
        driverId
        trackingNumber
        orderId
        taskDate
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
`;

// 基础数据查询
export const GET_ALL_DSPS = gql`
  query GetAllDsps {
    getAllDsps {
      id
      name
    }
  }
`;

// 使用全局的cities查询，与SLA页面保持一致

export const GET_ALL_AREAS = gql`
  query GetAllAreas {
    getAllAreas {
      id
      name
    }
  }
`;

// 类型定义
export interface DailyTaskMonitoringPageRequestType {
  filter: {
    taskDate: string;
    warehouseId?: number;
    dspIds?: number[];
    areaIds?: number[];
    driverIds?: number[];
  };
  pageRequest: {
    page: number;
    size: number;
    sortBy?: string;
    sortDirection?: 'ASC' | 'DESC';
  };
}

export interface DailyTaskMonitoringDetailPageRequestType {
  filter: {
    taskDate: string;
    hubId?: number;
    warehouseId?: number;
    dspIds?: number[];
    areaIds?: number[];
    driverIds?: number[];
    cities?: string[];
    trackingNumber?: string;
  };
  page: number;
  size: number;
}

export interface DailyTaskMonitoringSummaryType {
  deliveryProgress: {
    scheduledParcels: number;
    actualPickedUp: number;
    deliveredParcels: number;
    pickupRate: number;
    deliveryRate: number;
  };
  undeliveredDistribution: {
    totalUndelivered: number;
    unpicked: number;
    inDelivery: number;
    failedReturned: number;
    failedNotReturned: number;
    warehouseLost: number;
  };
}

export interface DailyTaskMonitoringType {
  id: number;
  taskDate: string;
  warehouseId: number;
  warehouseName?: string | null;
  dspId: number;
  areaId: number;
  driverId: number | null;
  allocatedParcels: number;
  pickedUpFromWarehouse: number;
  warehouseLost: number;
  inDelivery: number;
  deliveryRate: number;
  onTimeDelivery: number;
  overdueDelivery: number;
  deliveredCount?: number | null;
  unclaimedCount?: number | null;
  noAscanDelivery?: number | null;
  transferredIn: number;
  transferredOut: number;
  returned: number;
  damaged: number;
  driverName: string | null;
  lastDeliveryTime: string | null;
  dwellTime: string | null;
}

export interface DailyTaskMonitoringDetailType {
  id: number;
  taskDate: string;
  warehouseId: number;
  dspId: number;
  areaId: number;
  driverId: number | null;
  trackingNumber: string;
  orderId: number | null;
}

export interface DailyTaskMonitoringPageResponseType {
  content: DailyTaskMonitoringType[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
}

export interface DailyTaskMonitoringDetailPageResponseType {
  content: DailyTaskMonitoringDetailType[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
}

export interface DailyTaskMonitoringListData {
  calculatedAt?: string | null;
  summaryData: DailyTaskMonitoringSummaryType;
  recordData: DailyTaskMonitoringType[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
}

export interface GetWhsDailyTaskMonitoringListResponse {
  getWhsDailyTaskMonitoringList: DailyTaskMonitoringListData;
}

export interface GetDailyTaskMonitoringPageListResponse {
  getDailyTaskMonitoringPageList: {
    summaryData: DailyTaskMonitoringSummaryType;
    pageResponse: DailyTaskMonitoringPageResponseType;
  };
}

export interface GetDailyTaskMonitoringDetailListResponse {
  getDailyTaskMonitoringDetailList: DailyTaskMonitoringDetailPageResponseType;
}
